<!-- Template -->

<template>
    <div>
        <div v-for="pb in priceBooks" :key="pb.id" class="tree-container">
            <b-button v-b-toggle="'accordion-' + pb.id" class="configuration-item">
                <div>
                    <span class="arrow icon-chevron-right"></span>
                    <span class="code-and-title">{{pb.productCode}} {{pb.description}}</span>
                    <!-- <span class="title">{{pb.description}}</span> -->
                </div>
            </b-button>
            <b-collapse :id="'accordion-' + pb.id" class="mt-2">
                <b-card>
                    <p>Including:</p>
                    <ul>
                        <li v-for="part in pb.highLevelParts" :key="part.id">{{part.description}}</li>
                    </ul>
                </b-card>
            </b-collapse>
        </div>

        <div v-if="priceBooks.length == 0">
            <table class="table no-header training">
                <tbody>
                    <tr>
                        <td>
                            <p>System configurations do not exist.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<!-- Script -->

<script>
    export default {
        name: "SystemConfiguration",

        props: ["system"],

        data() {
            return {
                tempData: [],
                priceBooks: [],
                hasPriceBooks: null
            };
        },

        created() {
            if(this.system.priceBooks){
                var priceBooks = this.system.priceBooks;
                if (priceBooks.length > 0) {
                    for (var i = 0; i < priceBooks.length; i++) {
                        priceBooks[i].id = i;
                        for (var j = 0; j < priceBooks[i].highLevelParts.length; j++) {
                            priceBooks[i].highLevelParts[j].id = (i + j).toString();
                        }
                    }
                    this.priceBooks = priceBooks;
                    this.hasPriceBooks = true;
                } else {
                    this.hasPriceBooks = false;
                }
            }else{
                this.hasPriceBooks = false;
            }
        }
    };
</script>



